/** The report month the legacy page opened on: the PREVIOUS calendar month
 * (the monthly report is about the month that just ended). Legacy computed
 * it with a 0-based `getMonth()` and a falsy check, which lands on the
 * previous month for Feb–Dec and on December of the previous year in
 * January — i.e. always "last month"; kept as that intent. */
export function defaultReportMonth(now = new Date()): { year: number; month: number } {
  const m = now.getMonth() // 0-based: current month - 1 in 1-based terms
  return m === 0 ? { year: now.getFullYear() - 1, month: 12 } : { year: now.getFullYear(), month: m }
}

export function monthParam(year: number, month: number): string {
  return `${year}${String(month).padStart(2, '0')}`
}
